export default "__VITE_ASSET__CqCYyb1q__"